// extracted by mini-css-extract-plugin
export var chip = "_d3-0";
export var filterDropdown = "_d3-5";
export var filterItem = "_d3-6";
export var icon = "_d3-1";
export var removeButton = "_d3-3";
export var removeIcon = "_d3-4";
export var separator = "_d3-2";